import { render, staticRenderFns } from "./OrderUser.vue?vue&type=template&id=331f00ee&scoped=true&"
import script from "./OrderUser.vue?vue&type=script&lang=js&"
export * from "./OrderUser.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "331f00ee",
  null
  
)

export default component.exports